"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgWorldPin24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 18.6c-1.175-.95-1.25-4.075.6-4.8.982-.385 1.3 1.762 3.225 1.225.373-.104 1.25.425.93 1.231M8.577 7.672c.379.28.675.643.954 1.11.243.407.783 1.542.288 2.182-.56.724-2.182.968-2.182 1.636 0 .502.711 1.076 1.091 1.636.571.843.311 1.66 0 2.182-.161.27-.436.486-.722.658M17.88 11.4a6 6 0 1 1-5.007-4.737M17.4 7.8c0 1.481-2.4 3.6-2.4 3.6s-2.4-2.119-2.4-3.6c0-1.519 1.24-2.4 2.4-2.4s2.4.881 2.4 2.4Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgWorldPin24;
